import { Task } from '@repo/shared';
import { z } from 'zod';

export const statisticsFiltersSchema = z.object({
  task: z.nativeEnum(Task).optional(),
  model: z.string().optional(),
  date: z
    .object({
      from: z.string().optional(),
      to: z.string().optional(),
    })
    .optional(),
  createdBy: z.string().optional(),
});

export type StatisticsFiltersSchema = z.infer<typeof statisticsFiltersSchema>;
